import Box from '@mui/material/Box';
import React from 'react';
import styles from './page-wrapper.module.scss';
import classNames from 'classnames';

interface SimplePageWrapperProps {
    children: React.ReactNode;
    wrapperClassName?: string;
    contentClassName?: string;
}

export default function SimplePageWrapper({ children, wrapperClassName, contentClassName }: SimplePageWrapperProps) {
    const wrapperClasses = classNames(styles.pageWrapper, wrapperClassName);
    const contentClasses = classNames(styles.content, contentClassName);

    return (
        <Box className={wrapperClasses}>
            <div className={contentClasses}>
                {children}
            </div>
        </Box>
    );
}
